import { useEffect, useState } from "react";
import Detalle from "./Detail";
import { useParams, useSearchParams, useNavigate } from "react-router";

import { PageTabs } from "@/components/ui/page-tabs";

type TableDetailTabsType = "detalles" | "historial";

const tableDetailTabs = [
  { label: "Detalles", key: "detalles" },
  { label: "Historial", key: "historial" },
];

export const DetalleTabla = () => {
  const [activeTab, setActiveTab] = useState<"detalles" | "historial">(
    "detalles",
  );

  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const navigate = useNavigate();

  useEffect(() => {
    if (type === "historial") {
      setActiveTab("historial");
      const params = new URLSearchParams(searchParams);
      params.delete("type");
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [type, searchParams, navigate]);

  return (
    <div className="w-full flex flex-col max-h-full overflow-hidden h-full">
      {/* Tabs */}
      <PageTabs
        tabs={tableDetailTabs}
        activeKey={activeTab}
        onTabChange={(key) => {
          setActiveTab(key as TableDetailTabsType);
        }}
      />

      {activeTab === "detalles" ? <Detalle tableId={id as string} /> : <></>}
    </div>
  );
};
